import { render, staticRenderFns } from "./LexinKeyboardSelectLanguage.vue?vue&type=template&id=35dc7c61&"
import script from "./LexinKeyboardSelectLanguage.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardSelectLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports